import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 20px;
  border: 1px solid ${COLORS.borderDefault};
  border-radius: 12px;
  background-color: ${COLORS.bgWhite};
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SummaryLabel = styled.span`
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.075px;
  color: ${COLORS.textSecondary};
`

export const SummaryValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${COLORS.textPrimary};
`

export const SummaryFreeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: ${COLORS.bgInformativeSubtle};
  color: ${COLORS.fgInformative};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.06px;
`

export const SummaryDivider = styled.div`
  height: 1px;
  margin: 8px 0;
  background-color: ${COLORS.borderDefault};
`

export const SummaryTotalLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`

export const SummaryTotalValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`
